var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlaneLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.813.296L1.062 17.959c-1.528.91-1.375 3.226.252 3.917l9.31 3.964v6.973c0 2.064 2.51 2.96 3.766 1.387l4.03-5.044 8.395 3.568c1.268.54 2.703-.287 2.909-1.689l4.25-28.51C34.246.698 32.34-.614 30.813.294zM12.75 32.813v-6.07l3.619 1.538-3.62 4.532zM27.625 30.7l-13.693-5.824L27.18 8.758c.319-.383-.192-.902-.564-.574L9.662 23.058 2.124 19.86 31.875 2.19l-4.25 28.512z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneLight);
export default __webpack_public_path__ + "static/media/paper-plane-light.843c97cf.svg";
export { ForwardRef as ReactComponent };